import { type ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface CardProps {
  children: ReactNode;
  title?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  className?: string;
}

const paddings = {
  none: '',
  sm: 'p-3',
  md: 'p-5',
  lg: 'p-8',
};

export default function Card({ children, title, padding = 'md', className }: CardProps) {
  return (
    <div
      className={cn(
        'rounded-xl border border-line bg-surface shadow-sm',
        paddings[padding],
        className
      )}
    >
      {title && (
        <h3
          className={cn(
            'text-lg font-semibold text-ink',
            padding !== 'none' ? 'mb-4' : 'px-5 pt-5 mb-4'
          )}
        >
          {title}
        </h3>
      )}
      {children}
    </div>
  );
}
